const contextKeys = ['blueprintArn'];

export { contextKeys };
